import { render, staticRenderFns } from "./sourcecode.vue?vue&type=template&id=8769a204&"
import script from "./sourcecode.vue?vue&type=script&lang=js&"
export * from "./sourcecode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports